import { RolesEnum } from '../enums/roles.enum';

const validRoles = Object.values(RolesEnum);

function isValidRoleName(roleName: unknown): roleName is RolesEnum {
  return (
    typeof roleName === 'string' && validRoles.includes(roleName as RolesEnum)
  );
}

export function normalizeRoleNames(
  roleName: RolesEnum | RolesEnum[] | null | undefined,
): RolesEnum[] {
  if (Array.isArray(roleName)) {
    return roleName.filter(isValidRoleName);
  }
  return isValidRoleName(roleName) ? [roleName] : [];
}

export function normalizeRoleNamesFromUnknown(roleName: unknown): RolesEnum[] {
  return normalizeRoleNames(
    roleName as RolesEnum | RolesEnum[] | null | undefined,
  );
}
